import axios from "axios";
import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_TRACK_REQUEST,
  ORDER_TRACK_SUCCESS,
  ORDER_TRACK_FAIL,
  WAITER_CALL_REQUEST,
  WAITER_CALL_SUCCESS,
  WAITER_CALL_FAIL,
} from "../constants/orderConstants";

/* 🛒 RENDELÉS LÉTREHOZÁSA */
export const createOrder = (order) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };

    const { data } = await axios.post(`/api/orders/add/`, order, config);

    dispatch({
      type: ORDER_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload:
        error.response?.data?.detail || "A rendelés leadása nem sikerült.",
    });
  }
};

/* 📡 RENDELÉS ÁLLAPOT KÖVETÉSE (vásárlói oldal) */
export const trackOrder = (id, token) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_TRACK_REQUEST });

    const { data } = await axios.get(`/api/orders/${id}/track/`, {
      params: { token },
    });

    dispatch({
      type: ORDER_TRACK_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ORDER_TRACK_FAIL,
      payload:
        error.response?.data?.detail || "Nem sikerült lekérni a rendelés állapotát.",
    });
  }
};

/* 🔔 PINCÉR HÍVÁSA */
export const callWaiter = (table) => async (dispatch) => {
  try {
    dispatch({ type: WAITER_CALL_REQUEST });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };

    const { data } = await axios.post(`/api/waiter-call/`, { table }, config);

    dispatch({
      type: WAITER_CALL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: WAITER_CALL_FAIL,
      payload:
        error.response?.data?.detail || "A pincér hívása nem sikerült.",
    });
  }
};
